<template>
  <div class="container-item container-side-image image-card">  
    <div class="row justify-content-center my-3">
      <div class="col-md-8 col-lg-7 col-xl-7 col-12 align-self-center">
        <div class="side-image">
          <ImageElement :imageData="imageData" />
        </div>
        </div>
      <div class="col-md-4 col-lg-4 col-xl-4 col-12 align-self-center">
        
        <div v-if="cardText.imageCredits" class="text-left creditos-picture">
          <span v-if="cardText.text">
            {{ cardText.text }}
          </span>
           <span class="author" v-html="cardText.imageCredits"></span>
        </div>
      </div>
    </div>    
  </div>
</template>

<style lang="scss">
.container-side-image {
  background-image: url('../assets/bg-carousel.png');
    background-color: #000;
    background-repeat: repeat-y;
  padding: 35px 15px;
  margin: 35px 0;

  .side-image {
    display: block;
    width: 100%;
    margin: 0 auto;
    max-width: 820px;
  }
}

.creditos-picture {
  color: #fff;
  font-family: "Noto Sans";
  padding: 0 15px;
  font-size: 21px;  

  span {
    font-size: 15px;
  }
  
  .author {
    font-size: 23px;
    color: #fff;
    font-weight: 400;
  }
}
</style>

<script>

  import images from '@/mixins/images'

  export default {
    name: 'SingleImage',
    mixins: [images],
    props: {
      cardText: Object 
    }
  }
</script>